(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    /**
     * @function productInfoSwiper()
     * @description 产品详情轮播
     */
    function productInfoSwiper() {
      var section = $('.esim-info-section');
      if (section.length === 0) return;

      var productCarousel = section.find('.product-carousel .swiper-container');
      var productCarouselThumb = section.find('.product-carousel-thumb .swiper-container');
      if (productCarousel.length === 0 || productCarouselThumb.length === 0) {
        console.error('Swiper containers not found.');
        return;
      }

      var Swiper1 = new Swiper(productCarouselThumb, {
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: section.find('.swiper-button-next'),
          prevEl: section.find('.swiper-button-prev'),
        },
        slideToClickedSlide: true,
      });

      var Swiper2 = new Swiper(productCarousel, {
        observer: true,
        observeParents: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        thumbs: {
          swiper: Swiper1,
        },
      });

      console.log('Swiper initialized:', Swiper1, Swiper2);
    }
    productInfoSwiper();
  })

  } catch(e) { console.error(e); }
})();
})();
